import CardKeyDemo from '../components/CardKeyDemo';
import Page from '../components/Page';
import { CAROUSEL_TYPES } from '../constants/carouselTypes';
import { useAppStore } from '../stores/useAppStore';
import { AnimatePresence, motion } from 'motion/react';

function PageKeyDemos() {
  const { content: { lets_talk_strategy: content }, setCardTouchPos } = useAppStore();
  const { openCarousel } = useAppStore((state) => state.carousel);

  const items = content?.items;

  const handleCardClick = (event, index) => {
    let x, y;

    if (event.touches) {
      // Evento táctil
      x = event.touches[0].clientX;
      y = event.touches[0].clientY;
    } else {
      // Evento de ratón
      x = event.clientX;
      y = event.clientY;
    }
    setCardTouchPos({x, y});
    
    openCarousel(index, CAROUSEL_TYPES.KEY_DEMOS);
  };

  // Mostrar loading o mensaje si no hay items
  if (!items || items.length === 0) {
    return (
      <Page className='flex items-center justify-center pl-64 pr-[13.75rem]'>
        <div className="text-white text-2xl">
          {!content ? 'Loading...' : ''}
        </div>
      </Page>
    );
  }

  return (
    <Page className='flex space-between overflow-hidden pt-600u pr-30u relative'>
      <div className='absolute top-200u left-1/2 text-120u font-extralight -translate-x-1/2 z-30'>{content.title}</div>
       <div 
          className='absolute top-400u left-1/2 text-42u font-light -translate-x-1/2'>Engage our experts and problem-solve your most pressing challenges in the AI era.</div>

      <div className='flex flex-wrap gap-x-130u gap-y-135u content-start justify-center overflow-hidden relative'>
        <AnimatePresence>
          {items.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, filter: "blur(3px)" }}
              animate={{ opacity: 1, filter: "blur(0px)" }}
              transition={{
                duration: 1.5,
                ease: "easeOut",
                delay: 0.3 + (index * 0.04)
              }}
            >
              <CardKeyDemo
                item={item}
                index={index}
                onClick={(event) => handleCardClick(event, index)}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </Page>
  );
}

export default PageKeyDemos;